import axios from "../../utils/axios";

export type TabPublishStateResponse = {
    isReadonly: boolean;
    readonlyReason: string;
}

export const getTabPublishState = (rfpId: string) => axios
    .get(`/api/v1/frontend/tenders/facility-manager/${ rfpId }/tab-publish-state`)
    .then((response: { data: { data: TabPublishStateResponse } }) => response.data.data)
